import { z } from 'zod';
const toolSchemaBuilder = (schema) => ({
    /**
     * Extends the basic schema with the given fields
     */
    extend: (fields) => toolSchemaBuilder(schema.extend(fields)),
    /**
     * Adds a page number to the schema, this is useful for tools that rely on pagination
     */
    withPagination: () => toolSchemaBuilder(schema.extend({
        // We need to coerce because LLMs were passing strings instead of numbers quite often (via MCP)
        page: z.coerce
            .number()
            .positive()
            .nullable()
            .describe('Use this to paginate through the results'),
    })),
    /**
     * Builds the schema
     */
    build: () => schema,
    /**
     * Returns the zod schema so far
     */
    schema,
});
export const createToolSchema = (
/** The type of the tool. This will be used as differentiator for the union with other tool schemas  */
type, 
/** Description of the tool. This will be used to help the LLM to understand the tool and its capabilities. Be as clear and concise as possible. */
description) => toolSchemaBuilder(z.object({ type: z.literal(type) }).describe(description));
//# sourceMappingURL=toolSchemaBuilder.js.map